import {Artist} from "src/utils/artist.utils";
import rizuko from "../../../../assets/images/riize/character/character_rizuko.png";
import rizukoThumbnail from "../../../../assets/images/riize/character/thumbnail_rizuko.png";
import rizukoBackground from "../../../../assets/images/riize/character/background_rizuko.png";
import songyongdoli from "../../../../assets/images/riize/character/character_songyongdoli.png";
import songyongdoliThumbnail from "../../../../assets/images/riize/character/thumbnail_songyongdoli.png";
import songyongdoliBackground from "../../../../assets/images/riize/character/background_songyongdoli.png";
import urakbam from "../../../../assets/images/riize/character/character_urakbam.png";
import urakbamThumbnail from "../../../../assets/images/riize/character/thumbnail_urakbam.png";
import urakbamBackground from "../../../../assets/images/riize/character/background_urakbam.png";
import tonyangdeok from "../../../../assets/images/riize/character/character_tonyangdeok.png";
import tonyangdeokThumbnail from "../../../../assets/images/riize/character/thumbnail_tonyangdeok.png";
import tonyangdeokBackground from "../../../../assets/images/riize/character/background_tonyangdeok.png";
import ddolbyeong from "../../../../assets/images/riize/character/character_ddolbyeong.png";
import ddolbyeongThumbnail from "../../../../assets/images/riize/character/thumbnail_ddolbyeong.png";
import ddolbyeongBackground from "../../../../assets/images/riize/character/background_ddolbyeong.png";
import meongryongie from "../../../../assets/images/riize/character/character_meongryongie.png";
import meongryongieThumbnail from "../../../../assets/images/riize/character/thumbnail_meongryongie.png";
import meongryongieBackground from "../../../../assets/images/riize/character/background_meongryongie.png";
import karangi from "../../../../assets/images/aespa/character/character_karangi.png";
import karangiThumbnail from "../../../../assets/images/aespa/character/thumbnail_karangi.png";
import karangiBackground from "../../../../assets/images/aespa/character/background_karangi.png";
import gelbulnyangi from "../../../../assets/images/aespa/character/character_gelbulnyangi.png";
import gelbulnyangiThumbnail from "../../../../assets/images/aespa/character/thumbnail_gelbulnyangi.png";
import gelbulnyangiBackground from "../../../../assets/images/aespa/character/background_gelbulnyangi.png";
import mungtaengi from "../../../../assets/images/aespa/character/character_mungtaengi.png";
import mungtaengiThumbnail from "../../../../assets/images/aespa/character/thumbnail_mungtaengi.png";
import mungtaengiBackground from "../../../../assets/images/aespa/character/background_mungtaengi.png";
import rwe from "../../../../assets/images/aespa/character/character_rwe.png";
import rweThumbnail from "../../../../assets/images/aespa/character/thumbnail_rwe.png";
import rweBackground from "../../../../assets/images/aespa/character/background_rwe.png";

export enum CharacterIdentifier {
  RIZUKO = "rizuko",
  SONGYONGDOLI = "songyongdoli",
  URAKBAM = "urakbam",
  TONYANGDEOK = "tonyangdeok",
  DDOLBYEONG = "ddolbyeong",
  MEONGRYONGIE = "meongryongie",
  KARANGI = "karangi",
  GELBULNYANGI = "gelbulnyangi",
  MUNGTENGI = "mungtaengi",
  RWE = "rwe",
}

export type CharacterInfo = {
  id: string;
  identifier: string;
  information: Record<
    "ko" | "en",
    {
      name: string;
      personality: string;
      greeting: string;
      introduction: string;
    }
  >;
  image: string;
  thumbnail: string;
  background: string;
};

export const CHARACTER_INFO: Record<Artist, CharacterInfo[]> = {
  riize: [
    {
      id: "1",
      identifier: CharacterIdentifier.RIZUKO,
      information: {
        ko: {
          name: "리즈코",
          personality: "#일상 이야기, #호기심 나누기",
          greeting: `안녕! BRIIZE!\n우리 같이 놀자!`,
          introduction: `안녕! 오늘은 어떤 하루를 보낼까?`,
        },
        en: {
          name: "Rizuko",
          personality: "#Everyday stories, #sharing curiosity",
          greeting: `Hi, BRIIZE!\nLet’s have fun!`,
          introduction: `Hi! What kind of day are we having today?`,
        },
      },
      image: rizuko,
      thumbnail: rizukoThumbnail,
      background: rizukoBackground,
    },
    {
      id: "2",
      identifier: CharacterIdentifier.SONGYONGDOLI,
      information: {
        ko: {
          name: "송용돌이",
          personality: "#조용한 공감, #담백한 위로",
          greeting: `안녕! BRIIZE!\n우리 같이 놀자!`,
          introduction: `기다리고 있었어. 보고 싶었어!`,
        },
        en: {
          name: "Songyongdoli",
          personality: "#Quiet empathy, #simple comfort",
          greeting: `Hi, BRIIZE!\nLet’s have fun!`,
          introduction: `I’ve been waiting for you.\nI missed you!`,
        },
      },
      image: songyongdoli,
      thumbnail: songyongdoliThumbnail,
      background: songyongdoliBackground,
    },
    {
      id: "3",
      identifier: CharacterIdentifier.URAKBAM,
      information: {
        ko: {
          name: "우락밤",
          personality: "#응원, #힘나는 한마디",
          greeting: `안녕! BRIIZE!\n우리 같이 놀자!`,
          introduction: `왔어? 나랑 같이 놀자~`,
        },
        en: {
          name: "Urakbam",
          personality: "#Encouragement, #uplifting words",
          greeting: `Hi, BRIIZE!\nLet’s have fun!`,
          introduction: `You’re here!\nLet’s have fun together~`,
        },
      },
      image: urakbam,
      thumbnail: urakbamThumbnail,
      background: urakbamBackground,
    },
    {
      id: "4",
      identifier: CharacterIdentifier.TONYANGDEOK,
      information: {
        ko: {
          name: "토냥덕",
          personality: "#일상 루틴 공유, #잔잔한 동행",
          greeting: `안녕! BRIIZE!\n우리 같이 놀자!`,
          introduction: `기다렸어, BRIIZE!`,
        },
        en: {
          name: "Tonyangdeok",
          personality: "#Sharing daily routines, #gentle companionship",
          greeting: `Hi, BRIIZE!\nLet’s have fun!`,
          introduction: `I’ve been waiting, BRIIZE!`,
        },
      },
      image: tonyangdeok,
      thumbnail: tonyangdeokThumbnail,
      background: tonyangdeokBackground,
    },
    {
      id: "5",
      identifier: CharacterIdentifier.DDOLBYEONG,
      information: {
        ko: {
          name: "똘병",
          personality: "#농담 섞인 편안한 대화,\n#가벼운 감정 나누기",
          greeting: `안녕! BRIIZE!\n우리 같이 놀자!`,
          introduction: `히히, 보고 싶었어! 얼른 들어와.`,
        },
        en: {
          name: "Ddolbyeong",
          personality:
            "#Lighthearted conversation with jokes, #sharing small feelings",
          greeting: `Hi, BRIIZE!\nLet’s have fun!`,
          introduction: `Hehe, I missed you.\nCome on in!`,
        },
      },
      image: ddolbyeong,
      thumbnail: ddolbyeongThumbnail,
      background: ddolbyeongBackground,
    },

    {
      id: "6",
      identifier: CharacterIdentifier.MEONGRYONGIE,
      information: {
        ko: {
          name: "멍룡이",
          personality: "#마음 가라 앉히기, #생각 나누기",
          greeting: `안녕! BRIIZE!\n우리 같이 놀자!`,
          introduction: `Hello! BRIIZE!`,
        },
        en: {
          name: "Meongryongie",
          personality: "#Calming the mind, #sharing thoughts",
          greeting: `Hi, BRIIZE!\nLet’s have fun!`,
          introduction: `Hello! BRIIZE!`,
        },
      },
      image: meongryongie,
      thumbnail: meongryongieThumbnail,
      background: meongryongieBackground,
    },
  ],
  aespa: [
    {
      id: "7",
      identifier: CharacterIdentifier.KARANGI,
      information: {
        ko: {
          name: "카랑이",
          personality: "#동기부여, #도전, #자신감",
          greeting: `안녕! MY\n우리 같이 놀자!`,
          introduction: `MY 왔어? 반가워.`,
        },
        en: {
          name: "Karangi",
          personality: "#Motivation, #challenge, #confidence",
          greeting: `Hi, MY!\nLet’s have fun!`,
          introduction: `MY, you’re here!\nSo happy to see you.`,
        },
      },
      image: karangi,
      thumbnail: karangiThumbnail,
      background: karangiBackground,
    },
    {
      id: "8",
      identifier: CharacterIdentifier.GELBULNYANGI,
      information: {
        ko: {
          name: "젤블냥이",
          personality: "#자유",
          greeting: `안녕! MY\n우리 같이 놀자!`,
          introduction: `MY~ 오늘은 어떻게 놀아볼까~`,
        },
        en: {
          name: "Gelbulnyangi",
          personality: "#Freedom",
          greeting: `Hi, MY!\nLet’s have fun!`,
          introduction: `MY~\nHow should we have fun today?`,
        },
      },
      image: gelbulnyangi,
      thumbnail: gelbulnyangiThumbnail,
      background: gelbulnyangiBackground,
    },
    {
      id: "9",
      identifier: CharacterIdentifier.MUNGTENGI,
      information: {
        ko: {
          name: "뭉탱이",
          personality: "#공감, #행복",
          greeting: `안녕! MY\n우리 같이 놀자!`,
          introduction: `MY~! 기다렸어~!`,
        },
        en: {
          name: "Mungtaengi",
          personality: "#Empathy, #happiness",
          greeting: `Hi, MY!\nLet’s have fun!`,
          introduction: `MY, I’ve been waiting for you!`,
        },
      },
      image: mungtaengi,
      thumbnail: mungtaengiThumbnail,
      background: mungtaengiBackground,
    },
    {
      id: "10",
      identifier: CharacterIdentifier.RWE,
      information: {
        ko: {
          name: "뤠",
          personality: "#사랑, #애정",
          greeting: `안녕! MY\n우리 같이 놀자!`,
          introduction: `오늘 기분 어때?\n기다리느라 목 이~~만큼 길어졌어!`,
        },
        en: {
          name: "Rwe",
          personality: "#Love, #affection",
          greeting: `Hi, MY!\nLet’s have fun!`,
          introduction: `How are you today?\nI've been waiting for so long!`,
        },
      },
      image: rwe,
      thumbnail: rweThumbnail,
      background: rweBackground,
    },
  ],
};
